<div class="c-sona-root-layout__toolbar">
    <div class="tw-flex tw-items-center tw-gap-8 lg:tw-gap-16">
        <div class="tw-flex tw-items-center tw-gap-4">
            <ng-container *ngTemplateOutlet="logoLink" />
        </div>
        @if (isAuthenticated()) {
            <nav class="tw-contents">
                <ul class="tw-contents lg:tw-text-lg">
                    <li class="tw-inline">
                        <a class="tw-opacity-80 data-[state=active]:tw-opacity-100 hover:tw-no-underline" [routerLink]="['/']" routerLinkActive="active"
                           [routerLinkActiveOptions]="{ exact: true }">
                            {{ 'NAV.HOME' | translate }}
                        </a>
                    </li>
                    <li class="tw-inline">
                        <a class="tw-opacity-80 data-[state=active]:tw-opacity-100 hover:tw-no-underline" [routerLink]="['/domains']" routerLinkActive="active">
                            {{ 'NAV.DOMAINS' | translate }}
                        </a>
                    </li>
                </ul>
            </nav>
        }
    </div>

    <div class="tw-flex tw-flex-row tw-gap-4 tw-items-center">
        @if (isAuthenticated() && !isMobile()) {
            <sona-starter-audit-balance />
            <sona-credits-balance />
        }
        <sona-auth-user-menu>
            @if(isMobile()){
                @if (isAuthenticated()) {
                    <hlm-menu-label class="tw-mb-1">Kontingent</hlm-menu-label>
                    <sona-starter-audit-balance />
                    <sona-credits-balance />
                }
                <hlm-menu-separator />
            }
        </sona-auth-user-menu>
    </div>
</div>
<div class="c-sona-root-layout__main" (cdkObserveContent)="updateScrollable()">
    <router-outlet />
    <sona-app-footer />
</div>

<ng-template #logoLink>
    <a [routerLink]="homeBreadcrumb.link">
        <img
            [ngSrc]="homeBreadcrumb.icon.src"
            [alt]="homeBreadcrumb.icon.alt"
            [width]="homeBreadcrumb.icon.width"
            [height]="homeBreadcrumb.icon.height" />
    </a>
</ng-template>